<template> 
    <div class="config-button" v-if="showLink">
        <button class="config-control-button" type="button" @touchstart="goToConfig" @click="clickGoToConfig" >
            Tap
        </button>
    </div>
</template> 

<script>
import { setTimeout } from 'timers';
    export default {
        name: 'ConfigBox',
        data() {
            return {
                clickerCount: 1,
                clickClickerCount: 1,
                isRunning: false
            }
        },
        computed: {
            showLink() {
                return window.env && window.env.isIpad;
            }
        },
        methods: {
            clickerTimeout() {
                let vm = this;
                if (this.clickerCount >= 3 || this.clickClickerCount >= 3) {
                    this.clickerCount = 1;
                    this.clickClickerCount = 1;
                    if (window.env && window.env.isIpad) {
                        this.$router.push({
                            path: '/config'
                        });
                    }
                } else {
                    this.clickerCount = 1;
                    this.clickClickerCount = 1;
                }
                this.isRunning = false
            },
            goToConfig: function(event){
                let vm = this;
                this.clickerCount++;
                if (!this.isRunning){
                    setTimeout(function(){
                        this.isRunning = true; 
                        vm.clickerTimeout()
                    }, 1500); 
                }
            },
            clickGoToConfig: function(event) {
                let vm = this;
                this.clickClickerCount++;
                if (!this.isRunning){
                    setTimeout(function(){
                        this.isRunning = true; 
                        vm.clickerTimeout()
                    }, 1500); 
                }
            }
        }
    }
</script>

<style scoped>

    .config-button {
        position: fixed; 
        right: 0;
        bottom: 0;
        z-index: 3; 
        height: 44px;
        width: 44px; 
    }
    button {
        background: transparent;
        /*background: rgba(0,0,0,0.5);*/
        height: 44px;
        width: 44px; 
        border: 0; 
        z-index: 9999;
        color:transparent;

        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; 

    }

</style>